import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import 'ag-grid-enterprise';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';

import { store } from './redux/store';

import './theme/naver-map.scss';

import './index.scss';

import App from './App';

const root = createRoot(document.getElementById('app') as HTMLElement);
root.render(
  <Provider store={store}>
    <App />
  </Provider>,
);

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/firebase-messaging-sw.js').catch((error) => {
      console.warn('[firebase-messaging-sw] register failed', error);
    });
  });
}
